import withPage from '@lib/page';
import CategoryPage from '@views/pages/category';

export default withPage(CategoryPage);
